import React, { useEffect, useState } from "react";
import "../Styles/TaskListView.css";
import "../Styles/Form/CradView.css";
import styled from "styled-components";
import SearchBoxIcon from "../Assets/SearchIcon.svg";
import { useNavigate } from "react-router-dom";
import ListLogo from "../Assets/ListLogo.svg";
import cardLogo from "../Assets/file.svg";
import { IoClose } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { SlOptionsVertical } from "react-icons/sl";
import axios from "axios";
import FormListViewIcon from "../Assets/FormListViewIcon.svg";
import { IoShareOutline } from "react-icons/io5";
import { createNewForm } from "../Redux/Reducer/FormSlices";
import { useDispatch } from "react-redux";
import cardViewFormIMage from "../Assets/cardViewFormIMage.png";
import threeDotsCardView from "../Assets/threeDotsCardView.png";
import createdbyIcon from "../Assets/createdbyIcon.png";
import ActiveListLogo from "../Assets/ActiveListLogo.svg";
import activecardLogo from "../Assets/activecardLogo.svg";
import action_icon from "../Assets/action_icon.svg";
import viewIcon from "../Assets/viewIcon.svg";
import editIcon from "../Assets/editIcon.png";
import cloneIcon from "../Assets/cloneIcon.svg";
import shareIcon from "../Assets/shareIcon.svg";
import renameIcon from "../Assets/renameIcon.svg";
import submissionIcon from "../Assets/submissionIcon.svg";
import folder_addIcon from "../Assets/folder-addIcon.svg";
import exportIcon from "../Assets/exportIcon.svg";
import deleteIcon from "../Assets/deleteIcon.svg";
import chevron_forward from "../Assets/chevron-forward.svg";
import xlsxicon from "../Assets/xlsxicon.svg";
import csvicon from "../Assets/csvicon.svg";
import formpdfIcon from "../Assets/formpdfIcon.svg";
import selectedformdelIcon from "../Assets/selectedformdelIcon.svg";
import formeditIcon from "../Assets/formeditIcon.svg";
import formShareIcon from "../Assets/formShareIcon.svg";
import addtofoldericon from "../Assets/addtofoldericon.svg";
import { Menu, MenuItem, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { IoDocumentTextOutline } from "react-icons/io5";
const ProfileBasedLinks = styled.div`
  display: flex;
  gap: 20px;
`;

const ListViewinForm = () => {
  const [selectedForm, setSelectedForm] = useState([]);
  const [listview, setListView] = useState(true);
  const [cardView, setCardView] = useState(false);

  // get user id
  const userId = localStorage.getItem("userId");

  //store all forms
  const [forms, setForm] = useState([]);
  const URl = process.env.REACT_APP_API;
  const handelGetAllForm = async () => {
    try {
      const response = await axios.get(`${URl}/index/${userId}`);
      if (response.data.success) {
        setForm(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    handelGetAllForm();
  }, []);

  const handelFormDelete = async () => {
    console.log(selectedForm);

    const URl = process.env.REACT_APP_API;

    try {
      const response = await axios.patch(`${URl}/forms/delete/${userId}`, {
        formIds: selectedForm,
      });
      if (response.status === 200) {
        handelGetAllForm();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="task-list-view">
      {/* <div className='task-list-view1'> */}
      {selectedForm.length > 0 ? (
        <div className="selected-search-box-container">
          <IoClose size={25} />
          <div className="selected-letter">
            {selectedForm.length}
            <span>selected </span>
          </div>
          <div className="action-icon">
            <img src={formShareIcon} alt="formShareIcon" />
          </div>
          <div className="action-icon" onClick={handelFormDelete}>
            <img src={selectedformdelIcon} alt="selectedformdelIcon" />
          </div>
          <div className="action-icon">
            <SlOptionsVertical color="#8493B2" />
          </div>
        </div>
      ) : (
        <div className="formlist-search-box-container">
          <div className="formlist-search-box">
            <img src={SearchBoxIcon} alt="" />
            <input
              type="text"
              placeholder="search..."
              className="search-box-style"
            />
          </div>
          <ProfileBasedLinks>
            <img
              src={listview ? ActiveListLogo : ListLogo}
              alt=""
              className="formlist-top-bar-logo"
              onClick={() => {
                setListView(true);
                setCardView(false);
              }}
            />
            <img
              src={cardView ? activecardLogo : cardLogo}
              alt=""
              className="formlist-top-bar-logo"
              onClick={() => {
                setListView(false);
                setCardView(true);
              }}
            />
          </ProfileBasedLinks>
        </div>
      )}
      {/* </div> */}

      {listview && (
        <ListViewComponent
          handelGetAllForm={handelGetAllForm}
          forms={forms}
          setSelectedForm={setSelectedForm}
          selectedForm={selectedForm}
        />
      )}
      {cardView && (
        <CardViewComponent forms={forms} handelGetAllForm={handelGetAllForm} />
      )}
    </div>
  );
};

export default ListViewinForm;

const ListViewComponent = ({
  forms,
  handelGetAllForm,
  setSelectedForm,
  selectedForm,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isExportMenuOpen, setIsExportMenuOpen] = useState(false);
  const [isDeleteActionOpen, setDeleteActionOpen] = useState(false);
  const [exportType, setExportType] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const [shareSubMenuAnchorEl, setShareSubMenuAnchorEl] = useState(null);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);

  const handelGetFormById = async (formId) => {
    const URl = process.env.REACT_APP_API;
    try {
      const response = await axios.get(`${URl}/forms/${formId}`);
      if (response.status === 200) {
        dispatch(createNewForm(response.data.form));
        navigate(`/create-form/${response.data.form._id}/question`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [formId, setFormId] = useState(null);

  const handleActionClick = (rowId) => {
    setIsActionMenuOpen(isActionMenuOpen === rowId ? null : rowId);
    setIsExportMenuOpen(false);
    setExportType(null);
    setFormId(rowId);
  };

  const handleExportClick = (e) => {
    e.stopPropagation();
    setIsExportMenuOpen(!isExportMenuOpen);
    setExportType(null);
  };
  const handleExportTypeClick = (type, e) => {
    e.stopPropagation();
    setExportType(type);
  };

  const handelDeleClick = (formId) => {
    setFormId(formId);
    setDeleteActionOpen(true);
    setAnchorEl(false);
  };

  const handelFormCancel = () => {
    setDeleteActionOpen(false);
  };
  const handelFormDelete = async () => {
    const URl = process.env.REACT_APP_API;
    try {
      const response = await axios.post(`${URl}/forms/delete`, {
        formIds: selectedForm,
      });
      if (response.status === 200) {
        handelGetAllForm();
        setDeleteActionOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handelExportXl = async () => {
    try {
      const URl = process.env.REACT_APP_API;
      const response = await axios.get(`${URl}/forms/export/xlsx/${formId}`, {
        responseType: "blob",
      });
      // Create a Blob from the response
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "questions.xlsx";

      // Append the link to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the Excel file:", error);
    }
  };

  const handelExportCsv = async () => {
    try {
      const URl = process.env.REACT_APP_API;
      const response = await axios.get(`${URl}/forms/export/csv/${formId}`, {
        responseType: "blob", // Ensure that the response is treated as a Blob
      });

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "text/csv" });

      // Create a link element to trigger the download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "questions.csv"; // Set the file name for the download
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link element
      document.body.removeChild(link);
    } catch (error) {
      console.log("Error downloading the file", error);
    }
  };
  const handelExportPdf = async () => {
    try {
      const URl = process.env.REACT_APP_API;
      const response = await axios.get(`${URl}/forms/export/pdf/${formId}`, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "questions.pdf"; 
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.log("Error downloading the file", error);
    }
  };

  const handelCloneForm = async () => {
    try {
      const URl = process.env.REACT_APP_API;
      await axios.post(`${URl}/forms/clone/${formId}`);
      handelGetAllForm();
    } catch (error) {
      console.log("Error clone the form", error);
    }
  };

  const handleSelectionForm = (newForm) => {
    setSelectedForm(newForm);
    console.log("Selected Row IDs:", newForm);
  };

  const handleMenuOpen = (event, formID) => {
    setSelectedForm(formID.id);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubMenuAnchorEl(null);
    setShareSubMenuAnchorEl(null);
  };
  const formatDate = (inputDate) => {
    if (inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date)) {
        throw new Error("Invalid date format");
      }

      const options = {
        month: "short",
        day: "numeric",
        year: "numeric",
      };

      const formattedDate = date.toLocaleDateString("en-US", options);
      return formattedDate.replace(",", ""); 
    }
  };
  const column = [
    {
      field: "firstName",
      headerName: "Form name",
      flex: 3,
      sortable: false,
      resizable: false,
      renderCell: (params) => {
        const name = params.row.formTitle;
        const updatedAt = params.row.updatedAt;
        return (
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            {/* <img src={FormListViewIcon} alt="FormListViewIcon"/> */}
            <div style={{ width: "40px", height: "40px", backgroundColor: '#1b51bb', borderRadius: '4px', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <IoDocumentTextOutline color="#fff" size={24} />
            </div>
            <div>
              <p className="formNameText_color">{name}</p>
              <div>
                <p></p>
                <p className="formupdateAt_color">
                  Updated on {formatDate(updatedAt)}
                </p>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "responseCount",
      headerName: "Responses",
      flex: 2,
      sortable: false,
      resizable: false,
      renderCell: (params) => {
        const count = params.row.responseCount;
        return <p className="responseText">{count} responses</p>;
      },
    },
    {
      field: "actionIcon",
      headerName: "",
      flex: 0.8,
      sortable: false,
      resizable: false,
      renderCell: (params) => (
        <div className="action-icons">
          <div
            className="action-icon"
            onClick={() => handelGetFormById(params.id)}
          >
            <img src={formeditIcon} alt="formeditIcon" />
          </div>
          <div className="action-icon">
            <img src={formShareIcon} alt="formShareIcon" />
          </div>
          <div className="action-icon">
            <img src={addtofoldericon} alt="addtofoldericon" />
          </div>
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 90,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: (params) => (
        <div>
          <img
            src={action_icon}
            alt="action_icon"
            onClick={(e) => handleMenuOpen(e, params.row)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
    },
  ];

  const handleSubMenuOpen = (event) => {
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setSubMenuAnchorEl(null);
  };

  const handleShareSubMenuClose = () => {
    setShareSubMenuAnchorEl(null);
  };
  const handleShareSubMenuOpen = (event) => {
    setShareSubMenuAnchorEl(event.currentTarget);
  };

  const handleOpenTypeExport = (event, type) => {
    setExportAnchorEl(event.currentTarget);
  };
  const handleCloseTypeExport = () => {
    setExportAnchorEl(null);
  };
  return (
    <>
      {isDeleteActionOpen && (
        <div className="formdelete-modal" style={{ zIndex: 10 }}>
          <div className="formdelete-overlay"></div>
          <div className="formdelete-modal-content">
            <h2>Delete Permanently?</h2>
            <p>
              This form's Entries & Reports will be deleted permanently. You
              cannot revert this action.
            </p>
            <p>Would you like to proceed?</p>
            <div className="form-delete-btns">
              <button
                className="formcancel-close-modal"
                onClick={handelFormCancel}
              >
                Cancel
              </button>
              <button
                className="formdelete-close-modal"
                onClick={handelFormDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <Paper sx={{ height: "90%", width: "100%" }}>
        <DataGrid
          rows={forms}
          columns={column}
          checkboxSelection
          rowHeight={90}
          onRowSelectionModelChange={(newSelectedForm) =>
            handleSelectionForm(newSelectedForm)
          }
          sx={{
            border: 0,
            "& .MuiDataGrid-columnSeparator": {
              display: "none",
            },
          }}
        />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          sx={{
            "& .MuiMenu-paper": {
              padding: "0 0.4rem",
            },
            "& .MuiMenuItem-root": {
              gap: "1rem",
              transition: "background-color 0.3s ease",
              padding: "0.5rem",
            },
            "& .MuiMenuItem-root:hover": {
              backgroundColor: "#f5f5f5", 
              color: "#1B51BB", 
            },
          }}
        >
          <MenuItem >
            <div
              className="list-form-action"
            >
              <img src={viewIcon} alt="viewIcon" />
              View
            </div>
          </MenuItem>
          <MenuItem onClick={() => handelGetFormById(selectedForm[0])}>
            <div className="list-form-action">
              <img src={editIcon} alt="editIcon" />
              Edit
            </div>
          </MenuItem>
          <MenuItem>
            <div className="list-form-action">
              <img src={cloneIcon} alt="cloneIcon" />
              Clone
            </div>
          </MenuItem>
          <MenuItem onClick={handleShareSubMenuOpen}>
            <div className="list-form-action" style={{ gap: "4rem" }}>
              <div className="list-form-action">
                <img src={shareIcon} alt="shareIcon" />
                Share
              </div>
              <div>
                <img src={chevron_forward} alt="chevron_forward" />
              </div>
            </div>
          </MenuItem>
          <Menu
            anchorEl={shareSubMenuAnchorEl}
            open={Boolean(shareSubMenuAnchorEl)}
            onClose={handleShareSubMenuClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              mt: -1, 
              ml: "-10px", 
              "& .MuiMenu-paper": {
                padding: " 0 0.5rem", 
              },
              "& .MuiMenuItem-root": {
                gap: "1rem",
                transition: "background-color 0.3s ease",
                padding: "0.5rem", 
                paddingRight: "3rem",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "#f5f5f5", 
                color: "#1B51BB",
              },
            }}
          >
            <MenuItem>
              <div className="list-form-action">Copy link</div>
            </MenuItem>
            <MenuItem>
              <div className="list-form-action">Share as form</div>
            </MenuItem>
          </Menu>
          <MenuItem>
            <div className="list-form-action">
              <img src={renameIcon} alt="renameIcon" />
              Rename
            </div>
          </MenuItem>
          <MenuItem>
            <div className="list-form-action">
              <img src={submissionIcon} alt="submissionIcon" />
              Submission
            </div>
          </MenuItem>
          <MenuItem>
            <div className="list-form-action">
              <img src={folder_addIcon} alt="folder_addIcon" />
              Add to folder
            </div>
          </MenuItem>
          <MenuItem onClick={handleSubMenuOpen}>
            <div className="list-form-action" style={{ gap: "3rem" }}>
              <div className="list-form-action">
                <img src={exportIcon} alt="exportIcon" />
                Export
              </div>
              <div>
                <img src={chevron_forward} alt="chevron_forward" />
              </div>
            </div>
          </MenuItem>
          <Menu
            anchorEl={subMenuAnchorEl}
            open={Boolean(subMenuAnchorEl)}
            onClose={handleSubMenuClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              mt: -1, 
              ml: "-10px",
              "& .MuiMenu-paper": {
                padding: " 0 0.5rem",
              },
              "& .MuiMenuItem-root": {
                gap: "0.5rem", 
                transition: "background-color 0.3s ease",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "#f5f5f5", 
                color: "#1B51BB",
              },
            }}
          >
            <MenuItem onClick={(e) => handleOpenTypeExport(e, "question")}>
              <div className="list-form-action">Export as Question</div>
            </MenuItem>

            <MenuItem onClick={(e) => handleOpenTypeExport(e, "response")}>
              <div className="list-form-action">Export as Response</div>
            </MenuItem>
            <Menu
              anchorEl={exportAnchorEl}
              open={Boolean(exportAnchorEl)}
              onClose={handleCloseTypeExport}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                mt: -1, 
                ml: "-12px",
                "& .MuiMenu-paper": {
                  padding: " 0 0.5rem", 
                },
                "& .MuiMenuItem-root": {
                  gap: "0.5rem",
                  transition: "background-color 0.3s ease",
                },
                "& .MuiMenuItem-root:hover": {
                  backgroundColor: "#f5f5f5", 
                  color: "#1B51BB",
                },
              }}
            >
              <MenuItem>
                <div className="list-form-action">
                  <img src={csvicon} alt="csvicon" />
                  Export as .csv
                </div>
              </MenuItem>
              <MenuItem>
                <div className="list-form-action">
                  <img src={xlsxicon} alt="xlsxicon" />
                  Export as .xlsx
                </div>
              </MenuItem>
              <MenuItem>
                <div className="list-form-action">
                  <img src={formpdfIcon} alt="formpdfIcon" />
                  Export as .pdf
                </div>
              </MenuItem>
            </Menu>
          </Menu>
          <MenuItem onClick={() => handelDeleClick()}>
            <div className="list-form-action">
              <img src={deleteIcon} alt="deleteIcon" />
              Delete
            </div>
          </MenuItem>
        </Menu>
      </Paper>
    </>
  );
};

const CardViewComponent = ({ forms }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log("------------------------------", forms, "++++++++++++++++++");

  const handelGetFormById = async (formId) => {
    const URl = process.env.REACT_APP_API;
    try {
      const response = await axios.get(`${URl}/forms/${formId}`);
      if (response.status === 200) {
        dispatch(createNewForm(response.data.form));
        navigate(`/create-form/${response.data.form._id}/question`);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="card-view-container">
      <div className="card-view-list-container">
        {forms?.map((form, index) => (
          <div
            className="single-card-form-view"
            key={index}
            onClick={() => handelGetFormById(form._id)}
          >
            <img src={cardViewFormIMage} alt="cardViewFormIMage" />
            <div className="formName-cardlistview">
              {form.formTitle.length > 20
                ? form.formTitle.slice(0, 20) + "..."
                : form.formTitle}
            </div>
            <div className="forms-details-cardsview">
              <div className="createdBY-name">
                <p>{form.responseCount} responses</p>
                <p className="img-created">
                  <img src={createdbyIcon} alt="createdbyIcon" /> Created by me
                </p>
              </div>
              {/* <div>
                <img src={threeDotsCardView} alt="threeDotsCardView" />
              </div> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// const
